import { createContext } from "react";
import type { ChatContextType } from "@/types/common/chat/context/chatContext";

export const API_MODE = {
  WS: 1,
  API: 2
};

export const ChatContext = createContext<ChatContextType>({
  socket: undefined,
  isConnected: false,
  allRooms: [],
  setAllRooms: () => {},
  metas: [],
  setMetas: () => {},
  venues: [],
  setVenues: () => {},
  apiMode: 1,
  setApiMode: () => {}
});
